import { useState } from 'react'
import { router } from '@inertiajs/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faBars, faChevronDown, faRightFromBracket,
  faUser, faGear, faMagnifyingGlass
} from '@fortawesome/free-solid-svg-icons'
import NotificationBell from '../NotificationBell'

export default function UserTopbar({ current_user, onMenuToggle, placeholder, children }) {
  const [profileOpen, setProfileOpen] = useState(false)
  const logout = () => { if (confirm('Yakin ingin keluar?')) router.delete('/logout') }

  return (
    <header className="h-16 bg-white border-b border-gray-200 flex items-center px-4 lg:px-6 gap-4 flex-shrink-0">
      <button className="lg:hidden text-gray-500 hover:text-gray-700" onClick={onMenuToggle}>
        <FontAwesomeIcon icon={faBars} className="w-5 h-5" />
      </button>

      {children ?? (placeholder && (
        <div className="flex-1 max-w-md">
          <div className="relative">
            <FontAwesomeIcon icon={faMagnifyingGlass} className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
            <input
              type="text"
              placeholder={placeholder}
              className="w-full pl-9 pr-4 py-2 text-sm bg-gray-100 border-0 rounded-lg focus:bg-white focus:ring-2 focus:ring-green-500 outline-none transition-all"
            />
          </div>
        </div>
      ))}

      <div className="ml-auto flex items-center gap-3">
        <NotificationBell href="/user/notifications" />
        <div className="relative">
          <button
            onClick={() => setProfileOpen(!profileOpen)}
            className="flex items-center gap-2 px-3 py-1.5 rounded-lg hover:bg-gray-100 transition-colors"
          >
            <div className="w-7 h-7 rounded-full bg-green-100 flex items-center justify-center">
              <FontAwesomeIcon icon={faUser} className="w-3.5 h-3.5 text-green-600" />
            </div>
            <span className="text-sm font-medium text-gray-700 hidden sm:block">{current_user?.name || 'Pengguna'}</span>
            <FontAwesomeIcon icon={faChevronDown} className="w-3 h-3 text-gray-400" />
          </button>
          {profileOpen && (
            <div className="absolute right-0 top-full mt-1 w-48 bg-white rounded-xl shadow-lg border border-gray-100 py-1 z-50">
              <div className="px-3 py-2 border-b border-gray-100">
                <div className="text-xs font-semibold text-gray-800">{current_user?.name}</div>
                <div className="text-[11px] text-gray-400 truncate">{current_user?.email}</div>
              </div>
              <a href="/user/settings" className="flex items-center gap-2 px-3 py-2 text-sm text-gray-600 hover:bg-gray-50">
                <FontAwesomeIcon icon={faGear} className="w-3.5 h-3.5" /> Pengaturan
              </a>
              <button onClick={logout} className="w-full flex items-center gap-2 px-3 py-2 text-sm text-red-600 hover:bg-red-50">
                <FontAwesomeIcon icon={faRightFromBracket} className="w-3.5 h-3.5" /> Keluar
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  )
}
